import { client } from '@app/data/iron';
import { useQuery } from '@tanstack/react-query';

const FETCH_NAVIGATION_FILTERS = async () => {
  const { data = [] } = await client.get(
    '/api/allBrowseFilters?type=navigation',
  );

  return data;
};

const useNavigationFilters = () =>
  useQuery(['navigationFilters'], FETCH_NAVIGATION_FILTERS, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

export default useNavigationFilters;
